<template>
  <el-container class="layout-container">
    <layout-aside />
    <el-container class="flex-center layout-backtop">
      <layout-header v-if="isFixedHeader" />
      <el-scrollbar ref="scrollbarRef">
        <layout-header v-if="!isFixedHeader" />
        <layout-main />
      </el-scrollbar>
    </el-container>
    <el-backtop target=".layout-backtop .el-scrollbar__wrap" />
  </el-container>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import useCrmebThemeConfigStore from '@/store/modules/themeConfig';
import LayoutAside from '../component/Aside.vue';
import LayoutHeader from '../component/Header.vue';
import LayoutMain from '../component/Main.vue';

const route = useRoute();
const themeStore = useCrmebThemeConfigStore();
const scrollbarRef = ref();

const isFixedHeader = computed(() => themeStore.themeConfig.isFixedHeader);

watch(
  () => route.path,
  () => {
    const wrap = scrollbarRef.value?.wrapRef;
    if (wrap) wrap.scrollTop = 0;
  },
);
</script>
